import { Box } from '@mui/material';
import React from 'react';

export interface RichTextRendererProps {
  html: string;
  className?: string;
  style?: React.CSSProperties;
}

export const RichTextRenderer = ({
  html,
  className,
  style,
}: RichTextRendererProps) => {
  const containsHtml = /<[^>]+>/.test(html);

  if (!containsHtml) {
    return (
      <Box
        component="div"
        className={className}
        style={style}
        sx={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}
      >
        {html}
      </Box>
    );
  }

  return (
    <Box
      component="div"
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
      sx={{
        '& p': {
          margin: 0,
          marginBottom: '0.5em',
          '&:last-child': {
            marginBottom: 0,
          },
        },
        '& ul, & ol': {
          marginLeft: '20px',
          paddingLeft: '0',
          marginTop: '0.5em',
          marginBottom: '0.5em',
        },
        '& li': {
          marginBottom: '4px',
        },
        '& b, & strong': {
          fontWeight: 600,
        },
        '& i, & em': {
          fontStyle: 'italic',
        },
        '& u': {
          textDecoration: 'underline',
        },
        wordBreak: 'break-word',
      }}
    />
  );
};
